import React from 'react'

import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'
import { random, times } from 'lodash'

const useStyles = makeStyles({
  skeletonChip: {
    borderRadius: '32px',
  },
})

const ChipsLoadingSkeleton = () => {
  const classes = useStyles()
  const count = random(12, 20)
  return (
    <Box
      width="100%"
      height="200px"
      display="flex"
      flexWrap="wrap"
      justifyContent="flex-start"
      alignContent="flex-start"
      fontSize="24px"
      aria-label="loading options"
    >
      {times(count, (idx) => {
        const width = random(90, 125)
        return (
          <Box
            key={idx}
            m={0.5}
            display="inline-block"
            role="progressbar"
          >
            <Skeleton
              variant="rect"
              width={width}
              height={40}
              animation="wave"
              className={classes.skeletonChip}
            />
          </Box>
        )
      })}
    </Box>
  )
}

export default ChipsLoadingSkeleton
